import { render, staticRenderFns } from "./BannerFooter.vue?vue&type=template&id=4759327e&scoped=true"
import script from "./BannerFooter.js?vue&type=script&lang=js&external"
export * from "./BannerFooter.js?vue&type=script&lang=js&external"
import style0 from "./BannerFooter.scss?vue&type=style&index=0&id=4759327e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4759327e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotTitle: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Title/Title.vue').default,HotButton: require('/home/runner/_work/app-hotmart-digital-learning/app-hotmart-digital-learning/components/Atoms/Button/Button.vue').default})
